module.exports = __webpack_public_path__ + "static/media/ruby.26faac5f.jpg";